import { isRealDriverId } from "@/utilities/user/isRealDriverId";

export type DriverCellContent =
  | { kind: "empty" }
  | { kind: "loading" }
  | { kind: "name"; name: string }
  | { kind: "unknown"; reason: "lookupFailed" | "notFound" };

export interface DriverNameLookup {
  names: Map<string, string>;
  isLoading: boolean;
  isError: boolean;
}

/**
 * What a driver cell shows, given the name lookup for the grid's drivers.
 *
 * A driver missing from a settled lookup is "unknown" rather than blank, so a cell never waits
 * forever and never hides that a driver is assigned. The reason tells a failed lookup apart from
 * an id no user has.
 */
export function driverCellContent(
  driverId: string | null | undefined,
  { names, isLoading, isError }: DriverNameLookup,
): DriverCellContent {
  if (!isRealDriverId(driverId)) return { kind: "empty" };
  const name = names.get(driverId);
  if (name) return { kind: "name", name };
  if (isLoading) return { kind: "loading" };
  return { kind: "unknown", reason: isError ? "lookupFailed" : "notFound" };
}
